/** Entry identity owns unsubmitted React state; accepted operations remain owner-scoped. */
export function directPurchaseEntryScope(entry) {
    return entry
        ? JSON.stringify({
            marketAddress: entry.purchase.marketAddress,
            outcomeIndex: entry.purchase.outcomeIndex,
            mint: entry.binding.mint,
            network: entry.binding.network,
            preferredMethod: entry.preferredMethod,
        })
        : 'funding';
}
